import { Exclude, Expose, Type } from "class-transformer";
import { IsArray, IsDate, IsDefined, IsInt, IsString } from "class-validator";

@Exclude()
export class CustomerFeedbackForDriver {
    @IsString()
    @Expose()
    public originLocationName: string;

    @IsString()
    @Expose()
    public destinationLocationName: string;

    @IsDate()
    @IsDefined()
    @Expose()
    @Type(() => Date)
    public departureAt: Date;

    @IsArray()
    @Expose()
    public locationNames: Array<string>;

    @IsInt()
    @Expose()
    public textScore?: number;

    @IsString()
    @Expose()
    public text: string;
}
